import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ContactUs from "../Modals/ContactUs";

interface SectionProps {
  image: string;
  header: string;
  description: string[];
  buttonText: string;
  buttonLink: string;
}

const SplitSection: React.FC<SectionProps> = ({
  image,
  header,
  description,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 4 },
        backgroundColor: "#070a10",
      }}
    >
      <Grid
        container
        spacing={4}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          maxWidth: 1280,
          mx: "auto",
        }}
      >
        <Grid
          size={{ xs: 12, lg: 6 }}
          sx={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#fff",
              marginBottom: "1rem",
              fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2.125rem" },
            }}
          >
            {header}
          </Typography>

          <Box>
            {description.map((text, index) => (
              <Typography
                key={index}
                variant="body1"
                sx={{
                  color: "#94a3b8",
                  lineHeight: "1.8",
                  marginBottom: index < description.length - 1 ? "1rem" : "0",
                }}
              >
                {text}
              </Typography>
            ))}
          </Box>

          <Box>
            <ContactUs analyticsContext={{ source: "split_section" }} />
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, lg: 6 }}
          sx={{
            textAlign: "center",
          }}
        >
          <Box
            component="img"
            src={image}
            alt="section image"
            sx={{
              width: "100%",
              maxWidth: "800px",
              borderRadius: "16px",
              border: "1px solid rgba(51, 65, 85, 0.8)",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SplitSection;
